/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdgangAccessControl,
    AdgangAccessControlFromJSON,
    AdgangAccessControlToJSON,
} from '../models/AdgangAccessControl';
import {
    type ImportUserRequest,
    ImportUserRequestFromJSON,
    ImportUserRequestToJSON,
} from '../models/ImportUserRequest';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';
import {
    type UserImportResponse,
    UserImportResponseFromJSON,
    UserImportResponseToJSON,
} from '../models/UserImportResponse';

export interface ApiDevToolsAnsatteDateGetRequest {
    date: string;
}

export interface ApiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequest {
    orgId: any;
    date: string;
}

export interface ApiDevToolsAnsatteUserIdGetRequest {
    id: string;
}

export interface ApiDevToolsImportUserPostRequest {
    importUserRequest: ImportUserRequest;
}

export interface ApiDevToolsMdirskoleUserGetRequest {
    email?: string;
}

export interface ApiDevToolsOrganisasjonerIdGetRequest {
    id: string;
}

export interface ApiDevToolsPostCachePostRequest {
    body: string;
    expiration?: string;
}

export interface ApiDevToolsQmUserUserIdGetRequest {
    userId: string;
}

export interface ApiDevToolsRefreshUserCacheDerivedUserIdPostRequest {
    derivedUserId: string;
}

export interface ApiDevToolsStillingerGetRequest {
    id?: string;
}

/**
 * 
 */
export class DevToolsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiDevToolsAdgangAdministratorRightsPost without sending the request
     */
    async apiDevToolsAdgangAdministratorRightsPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/adgang-administrator-rights`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAdgangAdministratorRightsPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdgangAccessControl>>> {
        const requestOptions = await this.apiDevToolsAdgangAdministratorRightsPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdgangAccessControlFromJSON));
    }

    /**
     */
    async apiDevToolsAdgangAdministratorRightsPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdgangAccessControl>> {
        const response = await this.apiDevToolsAdgangAdministratorRightsPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiDevToolsAnsatteCountGet without sending the request
     */
    async apiDevToolsAnsatteCountGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ansatte/count`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAnsatteCountGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsAnsatteCountGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsAnsatteCountGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsAnsatteCountGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsAnsatteDateGet without sending the request
     */
    async apiDevToolsAnsatteDateGetRequestOpts(requestParameters: ApiDevToolsAnsatteDateGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling apiDevToolsAnsatteDateGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ansatte/{date}`;
        urlPath = urlPath.replace('{date}', encodeURIComponent(String(requestParameters['date'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAnsatteDateGetRaw(requestParameters: ApiDevToolsAnsatteDateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsAnsatteDateGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsAnsatteDateGet(requestParameters: ApiDevToolsAnsatteDateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsAnsatteDateGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGet without sending the request
     */
    async apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequestOpts(requestParameters: ApiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGet().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ansatte/organisasjonsId/{orgId}/fra/{date}`;
        urlPath = urlPath.replace('{orgId}', encodeURIComponent(String(requestParameters['orgId'])));
        urlPath = urlPath.replace('{date}', encodeURIComponent(String(requestParameters['date'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRaw(requestParameters: ApiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGet(requestParameters: ApiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsAnsatteOrganisasjonsIdOrgIdFraDateGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsAnsatteTestGet without sending the request
     */
    async apiDevToolsAnsatteTestGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ansatte/test`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAnsatteTestGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsAnsatteTestGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsAnsatteTestGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsAnsatteTestGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsAnsatteUserIdGet without sending the request
     */
    async apiDevToolsAnsatteUserIdGetRequestOpts(requestParameters: ApiDevToolsAnsatteUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiDevToolsAnsatteUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ansatte/user/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsAnsatteUserIdGetRaw(requestParameters: ApiDevToolsAnsatteUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsAnsatteUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsAnsatteUserIdGet(requestParameters: ApiDevToolsAnsatteUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsAnsatteUserIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsDfoEchoGet without sending the request
     */
    async apiDevToolsDfoEchoGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/dfo-echo`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsDfoEchoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsDfoEchoGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsDfoEchoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsDfoEchoGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsGenerateTestTokenGet without sending the request
     */
    async apiDevToolsGenerateTestTokenGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/generate-test-token`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsGenerateTestTokenGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.apiDevToolsGenerateTestTokenGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiDevToolsGenerateTestTokenGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiDevToolsGenerateTestTokenGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiDevToolsGetAnalyticsGet without sending the request
     */
    async apiDevToolsGetAnalyticsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/get-analytics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsGetAnalyticsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsGetAnalyticsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsGetAnalyticsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsGetAnalyticsGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsGetTxPost without sending the request
     */
    async apiDevToolsGetTxPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/get-tx`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsGetTxPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsGetTxPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsGetTxPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsGetTxPostRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsImportUserPost without sending the request
     */
    async apiDevToolsImportUserPostRequestOpts(requestParameters: ApiDevToolsImportUserPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['importUserRequest'] == null) {
            throw new runtime.RequiredError(
                'importUserRequest',
                'Required parameter "importUserRequest" was null or undefined when calling apiDevToolsImportUserPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/dev-tools/import-user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportUserRequestToJSON(requestParameters['importUserRequest']),
        };
    }

    /**
     */
    async apiDevToolsImportUserPostRaw(requestParameters: ApiDevToolsImportUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserImportResponse>> {
        const requestOptions = await this.apiDevToolsImportUserPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserImportResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDevToolsImportUserPost(requestParameters: ApiDevToolsImportUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserImportResponse> {
        const response = await this.apiDevToolsImportUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiDevToolsMdirskoleSyncExternalUsersPost without sending the request
     */
    async apiDevToolsMdirskoleSyncExternalUsersPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/mdirskole/sync-external-users`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsMdirskoleSyncExternalUsersPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsMdirskoleSyncExternalUsersPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsMdirskoleSyncExternalUsersPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsMdirskoleSyncExternalUsersPostRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsMdirskoleUserGet without sending the request
     */
    async apiDevToolsMdirskoleUserGetRequestOpts(requestParameters: ApiDevToolsMdirskoleUserGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/mdirskole/user`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsMdirskoleUserGetRaw(requestParameters: ApiDevToolsMdirskoleUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsMdirskoleUserGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsMdirskoleUserGet(requestParameters: ApiDevToolsMdirskoleUserGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsMdirskoleUserGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsMdirskoleUserPost without sending the request
     */
    async apiDevToolsMdirskoleUserPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/mdirskole/user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsMdirskoleUserPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsMdirskoleUserPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsMdirskoleUserPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsMdirskoleUserPostRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsMdirskoleUserPut without sending the request
     */
    async apiDevToolsMdirskoleUserPutRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/mdirskole/user`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsMdirskoleUserPutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsMdirskoleUserPutRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsMdirskoleUserPut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsMdirskoleUserPutRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsOrganisasjonerGet without sending the request
     */
    async apiDevToolsOrganisasjonerGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/organisasjoner`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsOrganisasjonerGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsOrganisasjonerGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsOrganisasjonerGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsOrganisasjonerGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsOrganisasjonerIdGet without sending the request
     */
    async apiDevToolsOrganisasjonerIdGetRequestOpts(requestParameters: ApiDevToolsOrganisasjonerIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiDevToolsOrganisasjonerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/organisasjoner/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsOrganisasjonerIdGetRaw(requestParameters: ApiDevToolsOrganisasjonerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsOrganisasjonerIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsOrganisasjonerIdGet(requestParameters: ApiDevToolsOrganisasjonerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsOrganisasjonerIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsPingCacheGet without sending the request
     */
    async apiDevToolsPingCacheGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/ping-cache`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsPingCacheGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsPingCacheGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsPingCacheGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsPingCacheGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsPostCachePost without sending the request
     */
    async apiDevToolsPostCachePostRequestOpts(requestParameters: ApiDevToolsPostCachePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling apiDevToolsPostCachePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['expiration'] != null) {
            queryParameters['expiration'] = requestParameters['expiration'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/dev-tools/post-cache`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async apiDevToolsPostCachePostRaw(requestParameters: ApiDevToolsPostCachePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsPostCachePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsPostCachePost(requestParameters: ApiDevToolsPostCachePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsPostCachePostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsQmUserGet without sending the request
     */
    async apiDevToolsQmUserGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/qm/user`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsQmUserGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsQmUserGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsQmUserGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsQmUserGetRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsQmUserPost without sending the request
     */
    async apiDevToolsQmUserPostRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/qm-user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsQmUserPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsQmUserPostRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsQmUserPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsQmUserPostRaw(initOverrides);
    }

    /**
     * Creates request options for apiDevToolsQmUserUserIdGet without sending the request
     */
    async apiDevToolsQmUserUserIdGetRequestOpts(requestParameters: ApiDevToolsQmUserUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiDevToolsQmUserUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/qm/user/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsQmUserUserIdGetRaw(requestParameters: ApiDevToolsQmUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsQmUserUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsQmUserUserIdGet(requestParameters: ApiDevToolsQmUserUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsQmUserUserIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsRefreshUserCacheDerivedUserIdPost without sending the request
     */
    async apiDevToolsRefreshUserCacheDerivedUserIdPostRequestOpts(requestParameters: ApiDevToolsRefreshUserCacheDerivedUserIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['derivedUserId'] == null) {
            throw new runtime.RequiredError(
                'derivedUserId',
                'Required parameter "derivedUserId" was null or undefined when calling apiDevToolsRefreshUserCacheDerivedUserIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/refresh-user-cache/{derivedUserId}`;
        urlPath = urlPath.replace('{derivedUserId}', encodeURIComponent(String(requestParameters['derivedUserId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsRefreshUserCacheDerivedUserIdPostRaw(requestParameters: ApiDevToolsRefreshUserCacheDerivedUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsRefreshUserCacheDerivedUserIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsRefreshUserCacheDerivedUserIdPost(requestParameters: ApiDevToolsRefreshUserCacheDerivedUserIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsRefreshUserCacheDerivedUserIdPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiDevToolsStillingerGet without sending the request
     */
    async apiDevToolsStillingerGetRequestOpts(requestParameters: ApiDevToolsStillingerGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/dev-tools/stillinger`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiDevToolsStillingerGetRaw(requestParameters: ApiDevToolsStillingerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiDevToolsStillingerGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDevToolsStillingerGet(requestParameters: ApiDevToolsStillingerGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDevToolsStillingerGetRaw(requestParameters, initOverrides);
    }

}
